import { render } from "./AppNotification.vue?vue&type=template&id=2bdb1aa4&ts=true"
import script from "./AppNotification.vue?vue&type=script&lang=ts"
export * from "./AppNotification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__